import BenchSeatPage from './BenchSeatPage';

const GALLERY_IMAGES = [
  { src: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&q=80', alt: 'Outdoor patio seating' },
  { src: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80', alt: 'Garden bench setting' },
  { src: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80', alt: 'Outdoor living space' },
];

const OutdoorBenchSeatPage = () => (
  <BenchSeatPage
    cushionId="outdoor-rectangle-bench-seat-cushion"
    galleryImages={GALLERY_IMAGES}
    defaultPreviewColor="#06b6d4"
    toastName="Outdoor Bench Seat Cushion"
    productName="Outdoor Bench Seat Cushion"
    productDescription="Weather-ready bench cushions built with UV-resistant outdoor fabrics and fast-drying foam. Designed to hold up to sun, rain, and everyday use on patios, pool decks, and garden benches."
    pageTestId="outdoor-bench-seat-page"
  />
);

export default OutdoorBenchSeatPage;
